import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function BecomeAgentBanner() {

  const [BecomeAgentBanner, setBecomeAgentBanner] = useState([]);

  useEffect(() => {
    const fetchBecomeAgentBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/become-agent/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setBecomeAgentBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBecomeAgentBanner();
  }, []);

  return (
    <Fragment>
      <div
        className="common-banner-sec common-flex-center agent-banner"
        style={{
          backgroundImage: `url(${
            apiUrl.apiUrl + `/` + BecomeAgentBanner.banner_image
          })`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="common-flex-center">
            <Col md={8}>
              <div className=" ">
                <h1 className="common-head whiteColor">{BecomeAgentBanner.banner_title}</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}

export default BecomeAgentBanner;
